import { createSlice } from "@reduxjs/toolkit";
import useProductListPageRoute from "../../../hooks/useProductListPageRoute";

type initialStateType = {
  collectionList: {
    title: string;
    url: string;
  }[];
  collection: {
    id?: string;
    handle?: string;
    title?: string;
    description?: string;
    products?: {
      nodes?: {
        title?: string;
        id?: string;
        description?: string;
        descriptionHtml?: string;
        productType?: string;
        priceRangeV2?: {
          minVariantPrice?: {
            amount?: string;
            currencyCode?: string;
          };
          maxVariantPrice?: {
            amount?: string;
            currencyCode?: string;
          };
        };
        featuredImage?: {
          url?: string;
        };
        metafields: {
          nodes: Array<{
            key: string;
            value: string;
            definition: {
              name: string;
            }
          }>;
        };
        variants?: {
          edges?: {
            node?: {
              sku?: string;
              id?: string;
            };
          }[];
        };
        tags?: string[];
        sellingPlanGroups: {
          edges: {
            node: {
              sellingPlans: {
                edges: {
                  node: {
                    id: string;
                  };
                }[];
              };
            };
          }[];
        };
      }[];
    };
  }[][];
  contractStatusList: {
    ID: number;
    status: string;
    contract_name: string;
    sku: string;
    partner_id: number;
  }[];
  metafieldKeyOrder: Array<{
    value: string;
    metadata: Array<{
      key: string;
    }>;
    description: string;
  }>;
  status: {
    collectionListLoading: boolean;
    loading: boolean;
    metafieldKeyOrderLoading: boolean;
    error: boolean;
    errorMessage: string;
    errorType: string;
  };
};

var initialState: initialStateType = {
  collectionList: [],
  collection: [[], [], [], []],
  contractStatusList: [],
  metafieldKeyOrder: [],
  status: {
    error: false,
    errorMessage: "",
    errorType: "",
    loading: false,
    collectionListLoading: false,
    metafieldKeyOrderLoading: false,
  },
};

const productList = createSlice({
  name: "plp",
  initialState: initialState,
  reducers: {
    setCollectionList: (state, action) => {
      state.collectionList = action.payload;
    },
    setCollectionListLoading: (state, action) => {
      state.status.collectionListLoading = action.payload;
    },
    setCollection: (state, action) => {
      state.collection[action?.payload?.subTypeIndex].push(action.payload.data);
    },
    setLoadingStatus: (state, action) => {
      state.status.loading = action.payload;
    },
    setContractStatusList: (state, action) => {
      state.contractStatusList = action.payload;
    },
    setMetafieldKeyOrder: (state, action) => {
      state.metafieldKeyOrder = action.payload;
    },
    setMetafieldKeyOrderLoading: (state, action) => {
      state.status.metafieldKeyOrderLoading = action.payload;
    },
    reset: (state) => {
      state.contractStatusList = [];
      state.collectionList = [];
      state.collection = [[], [], [], []];
      state.metafieldKeyOrder = [];
    },
  },
});

export const productListSliceReducer = productList.reducer;
export const productListSliceAction = productList.actions;
